
<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <EventTimeLine></EventTimeLine>
      </zj-layout-header>
      <zj-layout-main>
          <EventInfo :IsEdit="IsEdit"  :EventConfirm="EventConfirm" :IsAdd="IsAdd" :EventReport="EventReport"></EventInfo>
      </zj-layout-main>
    </zj-layout-container>
  </div>
</template>
<script>
import EventTimeLine from "./EventTimeLine.vue";
import EventInfo from "./EventInfo.vue";
export default {
  name: "ZjNewEvent",
  controller: "UI",
  action: "NewEvent",
  components: {
    EventTimeLine,EventInfo
  },
  data() {
    return {
      EventConfirm:false,  
      EventReport:false,
      IsAdd:true,
      
    };
  },
};
</script>